import {PersianHelper} from "./PersianHelper";
import _ from "lodash";

export const MarketHelper = {
    convertMarketCode,
    localNumberFormat,
    numberInputDecorator,
    isFiatMarketBySymbol,
    isFiatMarket,
    countDecimals,
    marketChangeCalculator,
    completePercentToText,
    completePercentToColorClass,
    retrieveMarketPrice,
    calculateTradeFee,
    tradeType: {
        0: 'فروش',
        1: 'خرید'
    },
    marketType: {
        LIMIT: 0,
        MARKET: 3,
        STOP_LIMIT: 1,
        OCO: 2
    },
    marketTypeTitles: {
        0: 'عادی (محدود)',
        3: 'سفارش‌سریع (مارکت)',
        1: 'Stop-Limit',
        2: 'OCO'
    },
    marketTypeENTitles: {
        0: 'limit',
        3: 'market',
        1: 'stop-limit',
        2: 'oco'
    },
    SELL: 0,
    BUY: 1,
    MINIMUM_FIAT_BUY: 100000,
    IRT: 'IRT',
    USDT: 'USDT',
    USDT_IRT: 'USDT_IRT',
    platformType: {
        SOON: 2,
        OTC: 1,
        P2P: 0
    },
    platformTypeName: {
        COMING_SOON: 'COMING SOON',
        OTC: 'OTC',
        P2P: 'P2P'
    },
    tradeStatus: {
        DONE: 0,
        NEED_SUPPORT: 1,
        ACTIVE: 2,
        MINOR: 3,
        CANCEL: 4
    },
    transformTradeStatus,
    MAXIMUM_PERCENT: 100
};

/**
 * Convert market code to separate details
 *
 * @param market
 * @returns {*}
 */
function convertMarketCode(market) {
    let [marketFrom, marketTo] = market.split('/');
    marketFrom = marketFrom.split('|');
    marketTo = marketTo.split('|');

    return {
        market: `${marketFrom[0]}/${marketTo[0]}`,
        from: marketFrom,
        to: marketTo
    };
}

/**
 *
 * @param number
 * @param isFiat
 * @param decimals is for limit on display decimal point
 * @param isMarket
 * @param withRounder
 * @param cleanNumber
 * @returns {string|number}
 */
function localNumberFormat(
    number, isFiat, decimals = 6,
    isMarket = false, withRounder = false,
    cleanNumber = false
) {
    const _ = require('lodash')
    let splitted = _.toString(number).split('.')

    if (isFiat) {
        if (typeof splitted[1] !== "undefined" && splitted[0] < 100) {
            isFiat = false
        }
    }

    if (isMarket) {
        if (_.toString(splitted[0]).length > 6)
            decimals = 1
        else if (_.toString(splitted[0]).length > 4 && _.toString(splitted[0]).length < 6)
            decimals = 2
        else if (_.toString(splitted[0]).length < 1) {
            decimals = PersianHelper.findNonZeroStep(number, 18)
        }
    } else {
        if (isFiat)
            decimals = ''
    }

    if (countDecimals(number) > decimals && typeof splitted[1] !== "undefined" && splitted[0] == 0 && splitted[0] < splitted[1])
        decimals = 6

    // Special for crypto and dollar that need to be round
    if (withRounder)
        return PersianHelper.numberFormat(number, null, decimals, '.', ',', true);

    let returnValue = isFiat ? PersianHelper.numberFormat(number, null, decimals, '', ',') :
        PersianHelper.numberFormat(number, null, decimals, '.', ',')

    if (cleanNumber)
        return PersianHelper.cleanNumber(returnValue)

    return returnValue
}

function numberInputDecorator(value) {
    value = PersianHelper.digitToEn(value)
    return PersianHelper.numberFormat(value, null, 0, '.', ',', false)
}

function countDecimals(value) {
    const _ = require('lodash')
    let text = _.toString(value)
    // verify if number 0.000005 is represented as "5e-6"
    if (text.indexOf('E-') > -1) {
        let [base, trail] = text.split('E-');
        let deg = parseInt(trail, 10);
        return deg;
    }
    // count decimals for number in representation like "0.123456"
    if (Math.floor(value) !== value) {
        return _.toString(value).split(".")[1]?.length || 0;
    }
    return 0;
}

function isFiatMarketBySymbol(marketSymbol, marketsBySymbol) {
    if (marketsBySymbol) {
        let currentMarket = marketsBySymbol[marketSymbol]
        return currentMarket.to[1].toLowerCase() === 'irt'
    }
}

function isFiatMarket(market) {
    if (market)
        return market.to[1].toLowerCase() === 'irt'
}

function marketChangeCalculator(start_price, current_price) {
    return start_price > 0 ? (
        parseFloat(start_price) >= parseFloat(current_price) ?
            (((start_price - current_price) / start_price) * 100) * -1
            :
            Math.abs(((current_price - start_price) / start_price) * 100)
    ) : 0
}

function completePercentToText(item) {
    let {status, is_active, complete_percent, market_type} = item
    if (status === true) {
        if (market_type === MarketHelper.marketType.MARKET) {
            if (Math.ceil(complete_percent) == 100)
                return 'انجام شده'
            else
                return 'تماس با پشتیبانی'
        } else {
            if (Math.ceil(complete_percent) == 100)
                return 'انجام شده'
            else
                return 'فعال'
        }
    } else {
        if (complete_percent > 0 && Math.ceil(complete_percent) !== 100)
            return 'جزئی'
        else
            return 'لغو شده'

    }
}

function completePercentToColorClass(item) {
    let {status, is_active, complete_percent, market_type} = item
    if (status === true) {
        if (market_type === MarketHelper.marketType.MARKET) {
            if (Math.ceil(complete_percent) == 100)
                return ''
            else
                return 'text-[#FFA846]'
        } else {
            if (Math.ceil(complete_percent) == 100)
                return ''
            else
                return ''
        }
    } else {
        if (complete_percent > 0 && Math.ceil(complete_percent) !== 100)
            return ''
        else
            return 'text-[#FFA846]'

    }
}

function transformTradeStatus(item) {
    let {status, complete_percent, market_type} = item
    if (status === true) {
        if (market_type === MarketHelper.marketType.MARKET) {
            if (Math.ceil(complete_percent) == 100)
                return MarketHelper.tradeStatus.DONE
            else
                return MarketHelper.tradeStatus.NEED_SUPPORT
        } else {
            if (Math.ceil(complete_percent) == 100)
                return MarketHelper.tradeStatus.DONE
            else
                return MarketHelper.tradeStatus.ACTIVE
        }
    } else {
        if (complete_percent > 0 && Math.ceil(complete_percent) !== 100)
            return MarketHelper.tradeStatus.MINOR
        else
            return MarketHelper.tradeStatus.CANCEL

    }
}

function retrieveMarketPrice(MarketPricesState, walletSymbol) {
    if (typeof MarketPricesState !== 'undefined' && MarketPricesState[`${walletSymbol}_IRT`] !== undefined) {
        return MarketPricesState[`${walletSymbol}_IRT`]?.current_price
    } else {
        return 0
    }
}

function calculateTradeFee(tradingTransactions) {
    let calculatedFee = 0
    tradingTransactions.map(item => {
        calculatedFee += Math.abs(
            (item.buyer_user ? item.value : item.value * item.unit) *
            ((item.buyer_user ? item.buyer_fee : item.seller_fee) / 100)
        )
    })

    return calculatedFee
}